import { GST_SEGMENTS, GST_URP_CODE, getGSTSegmentStates } from "../utils/validation";
import { B, fonts } from "./UI";

// Visual progress hint for the GST number input. Shows each regex segment of
// the GSTIN as a small chip and highlights the segment the user is currently
// typing in, with completed segments marked as done. Segments that are filled
// but do not match their pattern are shown in red as errors.
export default function GSTSegmentHint({ value }) {
  const normalized = String(value || "").trim().toUpperCase();
  if (normalized.length === 0) return null;
  // "URP" (Unregistered Person) is an accepted special value, not a partial
  // GSTIN; hide the segment chips so it is not flagged with pattern errors.
  if (normalized === GST_URP_CODE) return null;

  const states = getGSTSegmentStates(value);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 7 }}>
      {GST_SEGMENTS.map((segment, index) => {
        const state = states[index];

        // A segment is complete once it is fully filled and matches its pattern.
        const isComplete = state.isComplete;
        // A segment is an error once it is fully filled but does not match.
        const isError = state.isError;
        // The active segment is the one currently being typed (not yet full).
        const isActive = state.isActive;

        return (
          <span
            key={index}
            title={segment.label}
            style={{
              fontSize: 10,
              fontFamily: fonts.body,
              fontWeight: isActive ? 700 : 500,
              fontVariantNumeric: "tabular-nums",
              letterSpacing: "0.02em",
              padding: "3px 7px",
              borderRadius: 6,
              border: `1.5px solid ${
                isError ? B.red : isActive ? B.orange : isComplete ? B.green : B.border
              }`,
              background: isError
                ? B.redLight
                : isActive
                ? B.orangeFaint
                : isComplete
                ? B.greenLight
                : B.white,
              color: isError
                ? B.red
                : isActive
                ? B.orangeDark
                : isComplete
                ? B.green
                : B.textLight,
              boxShadow: isActive ? `0 0 0 2px ${B.orange}22` : "none",
              transition: "all 0.15s ease",
            }}
          >
            {segment.pattern}
            {isComplete && <span style={{ marginLeft: 3 }}>✓</span>}
            {isError && <span style={{ marginLeft: 3 }}>✗</span>}
          </span>
        );
      })}
    </div>
  );
}